import { ADD_TO_CART } from "../cart/actionTypes";

const cartPositionCounter = (store) => (next) => (action) => {
    const state = store.getState();
    const {cart} = state.cart;
    if(action.type === ADD_TO_CART){
   
        const newAction = {
            ...action,
            payload: {
                ...action.payload,
                cartPosition: cart.length
            }
        }

        return next(newAction)
    }
    return next(action);
}

export default cartPositionCounter;